import React from 'react';
import { MDBCol, MDBContainer, MDBIcon, MDBRow } from "mdbreact";
import TablePagination from '@material-ui/core/TablePagination';
import Button from '@material-ui/core/Button';
import TableComponent from '../../components/SharedComponents/Table';
import SelectField from '../../components/SharedComponents/SelectField/SelectField';
import BasicButton from '../../components/SharedComponents/BasicButton/BasicButton';
import InlineButtonField from '../../components/SharedComponents/InlineButtonField/InlineButtonField';
import {
    handlePaginationList,
    updateTableSortConfigObject,
    tableSortList,
} from "../../Common/TableHelper";
import messages from '../../Common/Messages.json';
import sizeLimits from '../../Common/SizeLimits.json';
import * as Constants from "../../../constants/constants";
import CasterService from "../../../services/service";
import { withUserContext } from '../../../contexts/UserContext';
import { lookupType, lookupConfig, seasonsLookupConfig } from './Config';
import './LookupValues.scss';
import MessageModal from '../../components/SharedComponents/MessageModal';
import { CircularProgress } from '@material-ui/core';

class LookupValues extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedType: "",
            lookupType: [],
            tableData: [],
            showContent: false,
            inlineButtonField: "",
            setIndex: 0,
            sortCount: 0,
            sortBy: "Value",
            isSortByAsc: true,
            config: lookupConfig,
            seasonPlaceHolders: ["Start Year", "End Year"],
            seasonValues: []
        }
    }

    componentDidMount() {
        this.setState({ lookupType: lookupType })
    }

    fetchDetails = (val) => {
        this.setState({ selectedType: val, isFetchingLookupValues: true, inlineButtonField: "", seasonValues: [], setIndex: 0 });
        CasterService.getData(Constants.CasterServiceBaseUrl + '/animationGetLookupData?entityType=' + val, this.props.userContext?.active_tenant?.tenant_id)
            .then(response => {
                let formattedList = response.data?.map(item => ({ value: item.lookup_data_id, label: item.lookup_value, check: item.is_active === 1 ? true : false,
                    lookup_key: item.lookup_key,
                    lookup_value: item.lookup_value,
                    lookup_value2: item.lookup_value2,
                    is_active: 1 }));
                this.setState({ 
                    tableData: formattedList, 
                    showContent: true, 
                    renderList: formattedList, 
                    isFetchingLookupValues: false 
                });
            },
                (err) => {
                    console.log("Error in fetching Market Types:", err)
                    this.setState({ isFetchingLookupValues: false })
                })
    }

    editList = (item) => {
        if (this.state.setIndex === 0) {
            if (this.state.inlineButtonField && this.state.inlineButtonField.length <= sizeLimits.nameCharacterLimit) {
                let details = JSON.parse(JSON.stringify([...this.state.tableData]))
                let dataItem = {
                    check: true,
                    value: null,
                    lookup_key: this.state.selectedType,
                    lookup_value: this.state.inlineButtonField,
                    lookup_value2: null,   
                }
                this.setState({inlineButtonField: "", isFetchingLookupValues: true, seasonValues: []},()=>{
                    this.handleSubmit(false,dataItem)
                })
            }
            if(this.state.selectedType === "SEASONS") {
                if (this.state.seasonValues && this.state.seasonValues.length > 1) {
                    let dataItem = {
                        check: true,
                        value: null,
                        lookup_key: this.state.selectedType,
                        lookup_value: this.state.seasonValues[0],
                        lookup_value2: this.state.seasonValues[1],   
                    }
                    this.setState({seasonValues: [], isFetchingLookupValues: true},()=>{
                        this.handleSubmit(false,dataItem)
                    })
                }
            }
        } else {
            // if (this.state.inlineButtonField.length <= sizeLimits.nameCharacterLimit) {
            //     let details = JSON.parse(JSON.stringify([...this.state.tableData]))
            //     let editDatalabel = details.find((item)=>item.value === this.state.setIndex).label
            //     let dataItem = {
            //         check: true,
            //         value: this.state.setIndex,
            //         lookup_key: this.state.selectedType,
            //         lookup_value: editDatalabel,
            //         lookup_value2: this.state.inlineButtonField,   
            //     }
            //     // this.setState({ tableData: details, formEdited: true, inlineButtonField: "", isFetchingLookupValues: true }, () => {
            //     //     this.handleSubmit(true);
            //     // });
            //     this.setState({ formEdited: true, inlineButtonField: "", isFetchingLookupValues: true }, () => {
            //         this.handleSubmit(true,dataItem);
            //     });
            // }
        }
    }

    handleSubmit = (setIndex = false,dataItem) => {
        let postData = {
            is_active: dataItem.check ? 1 : 0,
            lookup_data_id: dataItem.value,
            lookup_key: dataItem.lookup_key,
            lookup_value1: dataItem.lookup_value,
            lookup_value2: dataItem.lookup_value2,
        }
        
        CasterService.postDataParams(Constants.CasterServiceBaseUrl + '/animationPostLookupData',
            postData, this.props.userContext?.active_tenant?.tenant_id)
            .then(response => {
                this.fetchDetails(this.state.selectedType)
            //    if (setIndex) {
            //        this.setState({ setIndex: 0 })
            //    }
            },
                (err) => {
                    console.log("Error in fetching Work Details:", err)
                })
    }

   
    arrayCheckUncheck = (event, dataItem) =>{
        let details = JSON.parse(JSON.stringify([...this.state.tableData]))
        details?.map(item => {
            if (item.value === dataItem.value) {
                item.check = dataItem.check;
            }
        });
        this.setState({ tableData: details, formEdited: true }, () => {
            this.handleSubmit(false,dataItem);
        });
    }


    editData = (dataItem, node) => {
        console.log("check the data item on edit", dataItem)
        if(dataItem.lookup_key === "SEASONS") {
            this.setState({ seasonValues: [dataItem.lookup_value, dataItem.lookup_value2],setIndex: dataItem.value})    
        } else {
            this.setState({ inlineButtonField: dataItem.label,setIndex: dataItem.value})
        }
    }

    handleTableColumnClick = (column) => {
        if (column === this.state.sortBy) {
            this.setState({ sortCount: this.state.sortCount + 1 }, () => {
                this.handleTableSort(column);
            })
        }
        else this.setState({ sortCount: 0 }, () => {
            this.handleTableSort(column);
        })
    }

    getSortNode = (col) => {
        switch (col) {
            case "Value": return "label";
            case "Active": return "staticMode";
            case "Start Year": return "lookup_value";
            case "End Year": return "lookup_value2";
        }
    }

    handleTableSort = (colName) => {
        this.setState({
            isSortByAsc: this.state.sortCount % 2 === 0 ? true : false,
            config: updateTableSortConfigObject(this.state.selectedType == "SEASONS" ? seasonsLookupConfig : this.state.config, this.state.isSortByAsc, this.state.sortBy, colName)
        }, () => {
            this.setState({
                sortBy: colName,
                renderList: tableSortList("Name", this.getSortNode(colName), this.state.tableData, this.state.isSortByAsc)

            });
        })
    }

    setSeasonValue = (value, index) => {
        let seasonValues = [...this.state.seasonValues]
        seasonValues[index] = value
        this.setState({ seasonValues: seasonValues })
    }

    saveItem = (index, value) => {
        this.setState({ setIndex: 0, inlineButtonField: "", seasonValues: [], isFetchingLookupValues: true })
        let editedItem = this.state.renderList.find(item => item.value == index)
        editedItem.lookup_value = editedItem.lookup_key == "SEASONS" ? value[0]  : value
        editedItem.lookup_value2 = editedItem.lookup_key == "SEASONS" ? value[1]  : null
        editedItem.label = value[0]
        this.handleSubmit(false, editedItem);
    }

    render() {
        return (
            <MDBContainer className="ManageLookupContainer">
                <MDBRow>
                    <div className="pt3 helper-text">
                        <span> Select a system field to update their value list.</span>
                    </div>
                </MDBRow>
                <MDBRow className="pt2">
                    <MDBCol md={12}>
                        <div>
                            <SelectField
                                label="Selected Field"
                                placeHolderText={"- Select -"}
                                value={this.state.selectedType}
                                options={this.state.lookupType}
                                onChange={(e) => { this.fetchDetails(e.target.value) }}
                            />
                        </div>
                    </MDBCol>
                </MDBRow>
                <MDBRow className="pt3">
                    <MDBCol
                        className={`${this.state.renderList?.find(item => item.value === this.state.setIndex) ? 'highlightSelectedValue' : '' } lookup-table`}
                    >
                        <TableComponent
                            list={this.state.renderList || []}
                            config={ this.state.selectedType === "SEASONS" ? seasonsLookupConfig : lookupConfig}
                            isLoading={this.state.isFetchingLookupValues}
                            arrayCheckUncheck={this.arrayCheckUncheck}
                            editData={this.editData}
                            sortCallback={this.handleTableColumnClick}
                            noResultsText={"No Selection"}
                            // highlightValue={this.state.renderList?.find(item => item.value === this.state.setIndex)?.label}
                        />
                    </MDBCol>
                </MDBRow>
                <MDBRow>
                    {this.state.showContent ?
                        <div>
                            <MDBRow>
                                <MDBCol md={12}>
                                    <div className="pt5">
                                        <MDBCol md={9} className="inline-block">
                                            <InlineButtonField
                                                id={"key21"}
                                                label={this.state.setIndex === 0 ? "Add Value" : "Edit Value"}
                                                value={this.state.selectedType == "SEASONS" ? this.state.seasonValues : this.state.inlineButtonField}
                                                placeholder={this.state.selectedType == "SEASONS" ? this.state.seasonPlaceHolders : (this.state.setIndex === 0 ? "Add Value" : "Edit Value")}
                                                onChange={(e, index) => this.state.selectedType == "SEASONS" ? this.setSeasonValue(e.target.value, index) : this.setState({ inlineButtonField: e.target.value })}
                                                buttonOnClick={(e) => this.state.setIndex === 0 ? this.editList() : this.saveItem(this.state.setIndex, this.state.selectedType == "SEASONS" ? this.state.seasonValues : this.state.inlineButtonField)}
                                                totalTextFieldCount={this.state.selectedType == "SEASONS" ? 2 : 1}
                                                editIcon={this.state.setIndex === 0 ? "" : "save"}
                                                limit={sizeLimits.nameCharacterLimit}
                                                limitWarning={messages.exceed50CharacterWarning || ""}
                                            />
                                        </MDBCol>
                                        <MDBCol md={2} className="inline-block m-10">
                                        {this.state.setIndex != 0 &&  
                                            <BasicButton onClick ={() => this.setState({ setIndex: 0, inlineButtonField: "", seasonValues: [] })}
                                                variant = "contained"
                                                size = "small"
                                                color = "primary"
                                                text = "Cancel"
                                                />
                                        }
                                        </MDBCol>
                                    </div>
                                </MDBCol>
                            </MDBRow>
                        </div>
                        : null}
                </MDBRow>
            </MDBContainer>
        )
    }
}

export default withUserContext(LookupValues);